module.exports = __webpack_public_path__ + "static/media/S (45).c4fc4709.jpg";